module.exports = __webpack_public_path__ + "assets/b2b1214b09f2c5b4643008de4f420461.jpg";